// Refilling Management Types

export interface Refilling {
  refillingId: string;
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string; // Q1, Q2, Q3, Q4
  visitDate: string; // YYYY-MM-DD
  dcNo: string;
  abc_2_0_kg?: number;
  abc_4_0_kg?: number;
  abc_6_0_kg?: number;
  abc_9_0_kg?: number;
  co2_2_0_kg?: number;
  co2_4_5_kg?: number;
  co2_9_0_kg?: number;
  foam_9_0_lrs?: number;
  clean_agent_4_0_kg?: number;
  clean_agent_10_0_kg?: number;
  safety_pin?: number;
  pressure_gauge?: number;
  abc_hose?: number;
  co2_hose?: number;
  co2_valve?: number;
  abc_valve?: number;
  additional_field_1?: string;
  additional_field_2?: string;
  refillingDoc?: string; // Google Drive link (optional)
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  createdBy: string; // User ID
  createdByName?: string; // User name (for display)
}

export interface CreateRefillingRequest {
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string; // Q1, Q2, Q3, Q4
  visitDate: string;
  dcNo: string;
  abc_2_0_kg?: number;
  abc_4_0_kg?: number;
  abc_6_0_kg?: number;
  abc_9_0_kg?: number;
  co2_2_0_kg?: number;
  co2_4_5_kg?: number;
  co2_9_0_kg?: number;
  foam_9_0_lrs?: number;
  clean_agent_4_0_kg?: number;
  clean_agent_10_0_kg?: number;
  safety_pin?: number;
  pressure_gauge?: number;
  abc_hose?: number;
  co2_hose?: number;
  co2_valve?: number;
  abc_valve?: number;
  additional_field_1?: string;
  additional_field_2?: string;
  refillingDoc?: string;
}

export interface UpdateRefillingRequest extends CreateRefillingRequest {
  refillingId: string;
}

export interface RefillingFormData {
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string; // Q1, Q2, Q3, Q4
  visitDate: string;
  dcNo: string;
  abc_2_0_kg: string | number;
  abc_4_0_kg: string | number;
  abc_6_0_kg: string | number;
  abc_9_0_kg: string | number;
  co2_2_0_kg: string | number;
  co2_4_5_kg: string | number;
  co2_9_0_kg: string | number;
  foam_9_0_lrs: string | number;
  clean_agent_4_0_kg: string | number;
  clean_agent_10_0_kg: string | number;
  safety_pin: string | number;
  pressure_gauge: string | number;
  abc_hose: string | number;
  co2_hose: string | number;
  co2_valve: string | number;
  abc_valve: string | number;
  additional_field_1: string;
  additional_field_2: string;
  refillingDoc: string;
}

// Dropdown options
export const STATE_OPTIONS = [
  { value: "tamilnadu", label: "Tamil Nadu" },
  { value: "karnataka", label: "Karnataka" },
  { value: "pondicherry", label: "Pondicherry" },
];

export const VISIT_PERIOD_OPTIONS = [
  { value: "Q1", label: "Q1 (Jan-Mar)" },
  { value: "Q2", label: "Q2 (Apr-Jun)" },
  { value: "Q3", label: "Q3 (Jul-Sep)" },
  { value: "Q4", label: "Q4 (Oct-Dec)" },
];

export const QUANTITY_FIELDS = [
  { key: "abc_2_0_kg", label: "ABC 2.0 KG" },
  { key: "abc_4_0_kg", label: "ABC 4.0 KG" },
  { key: "abc_6_0_kg", label: "ABC 6.0 KG" },
  { key: "abc_9_0_kg", label: "ABC 9.0 KG" },
  { key: "co2_2_0_kg", label: "CO2 2.0 KG" },
  { key: "co2_4_5_kg", label: "CO2 4.5 KG" },
  { key: "co2_9_0_kg", label: "CO2 9.0 KG" },
  { key: "foam_9_0_lrs", label: "Foam 9.0 Lrs" },
  { key: "clean_agent_4_0_kg", label: "Clean Agent 4.0 Kg" },
  { key: "clean_agent_10_0_kg", label: "Clean Agent 10.0 Kg" },
  { key: "safety_pin", label: "Safety Pin" },
  { key: "pressure_gauge", label: "Pressure Gauge" },
  { key: "abc_hose", label: "ABC Hose" },
  { key: "co2_hose", label: "CO2 Hose" },
  { key: "co2_valve", label: "CO2 Valve" },
  { key: "abc_valve", label: "ABC Valve" },
];

export const TEXT_FIELDS = [
  { key: "additional_field_1", label: "Additional Field 1" },
  { key: "additional_field_2", label: "Additional Field 2" },
];
